import { Box } from '@mui/material';
import React from 'react';

type TabPanelWrapperProps = {
  children: React.ReactNode;
  selected: boolean;
};

const TabPanelWrapper = ({ children, selected }: TabPanelWrapperProps) => {
  if (!selected) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      {children}
    </Box>
  );
};

export default TabPanelWrapper;
